const $ = require('jquery');

const newsletterSignup = function () {

	$.fcutrecht = $.ajax;
	var attemptedSignup = false;

	if(sessionStorage.getItem("newsletterSignedup")){
		$("#newsLetterContainer").hide();
	}

	$("#newsletterSignup").click(function () {
		$("#newsletterSignupForm").submit();		
	});

	$("#newsletterSignupForm").submit(function(e){
	
		if(!$("#newsletterSignupForm").valid()){
			return false;
		}

		$("#newsletterSignup").hide()
	
		if(!attemptedSignup){
			$.fcutrecht({
				type: "POST",
				url: "/umbraco/api/Newsletter/Signup",
				dataType: "json",
				contentType: "application/json",
				data: JSON.stringify({
					"Email" : $("input[name='postModel.Email']").val(),
					"Accept" : true
				}),
				success: function() {
					sessionStorage.setItem('newsletterSignedup', true);
					$("#newsLetterContainer").hide();		
					$("#newsLetterSuccess").show();
				},
				error: function() {
					$("#newsLetterContainer").hide();		
					$("#newsLetterFail").show();
				}
			});
		}

		attemptedSignup = true;
		
		e.preventDefault();
	});

}

module.exports = newsletterSignup;
